import React from 'react';
import {LessonData} from "features/model/types/lessosnSchema";
import {useParams} from "react-router-dom";


interface LessonActionsTeacherProps {
    lesson: LessonData;
    startLessonHandler: () => void;
    joinMeetingHandler: (id: string) => void;
    startMeetingHandler: (id: string) => void;
    isLoadingAction: boolean;
    lessonsId:string | undefined
}

export const LessonActionsTeacher: React.FC<LessonActionsTeacherProps> = ({ lesson, startLessonHandler, joinMeetingHandler, startMeetingHandler, isLoadingAction }) => {
    const {lessonsId} = useParams();
    if (lesson.status === 'new') {
        return (
            <div className="col action-col">
                <button
                    className="btn"
                    onClick={startLessonHandler}
                    disabled={isLoadingAction}
                >
                    <a
                        style={{boxShadow: 'none'}}
                        href={lesson.link}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <span>{isLoadingAction ? 'Загрузка...' : 'Начать занятие'}</span>
                    </a>
                </button>
            </div>
        );
    } else if (lesson.status === 'inProgress' && lesson.meetingIsRunning) {
        return (
            <div className="col action-col">
                <button
                    className="btn"
                    onClick={() => joinMeetingHandler(lessonsId as string)}
                    disabled={isLoadingAction}
                >
                    <a
                        style={{boxShadow: 'none'}}
                    >
                        <span>{isLoadingAction ? 'Загрузка...' : 'Войти в занятие'}</span>
                    </a>
                </button>
            </div>
        );
    } else if (lesson.status === 'inProgress' && !lesson.meetingIsRunning) {
        return (
            <div className="col action-col">
                <button
                    className="btn"
                    onClick={() => startMeetingHandler(lessonsId as string)}
                    disabled={isLoadingAction}
                >
                    <a
                        style={{boxShadow: 'none'}}
                    >
                        <span>{isLoadingAction ? 'Загрузка...' : 'Создать комнату'}</span>
                    </a>
                </button>
            </div>
        );
    }

    return null;
};

